@if (!linkHref) {
  <button (click)="!disabled && !submitting && emitClick.emit()" class="button-component {{classes}}" [class.button--disabled]="disabled" [class.button--submitting]="submitting">
    @if (icon) {
      <div class="button-pre-wrap">
        <!-- icon -->
        @if (!submitting) {
          <i class="im-icon im-icon-{{icon}}" [ngStyle]="{'font-size' : iconSize }"></i>
        }
        <!-- submitting -->
        @if (submitting) {
          <app-inline-spinner></app-inline-spinner>
        }
      </div>
    }
    <!-- text -->
    <span>{{text}}</span>
  </button>
}
@if (linkHref) {
  <a [attr.href]="linkHref" target="{{linkTarget ? linkTarget : '_self'}}" (click)="!disabled && !submitting && emitClick.emit()" class="button-component {{classes}}" [class.button--disabled]="disabled" [class.button--submitting]="submitting">
    @if (icon) {
      <div class="button-pre-wrap">
        <!-- icon -->
        @if (!submitting) {
          <i class="im-icon im-icon-{{icon}}" [ngStyle]="{'font-size' : iconSize }"></i>
        }
        <!-- submitting -->
        @if (submitting) {
          <app-inline-spinner></app-inline-spinner>
        }
      </div>
    }
    <!-- text -->
    <span>{{text}}</span>
  </a>
}